import { render, staticRenderFns } from "./userActive.vue?vue&type=template&id=ab0b1b4c&"
import script from "./userActive.vue?vue&type=script&lang=js&"
export * from "./userActive.vue?vue&type=script&lang=js&"
import style0 from "./userActive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports